/** @jsxImportSource @emotion/react */
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import isTest from '@purecarslabs/signal-utils/env/isTest'

const ScrollToTop = () => {
  // we can't use useLocation() hook in unit tests.  It's okay to suspend eslint because in a non-test scenario, we
  // will always use this hook
  const pathname = isTest() ? '/test/path' : useLocation().pathname // eslint-disable-line react-hooks/rules-of-hooks

  useEffect(() => {
    if (isTest) {
      window.scrollTop = 0
    } else {
      window.scrollTo(0, 0)
    }
  }, [pathname])

  return null
}

export default ScrollToTop
